import RouteConstants from '@/features/router/RouteConstants';
import { Button } from '@/lib';
import { FC } from 'react';
import { HiPlus } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type AudienceRequiredEmptyStateProps = {
  className?: string;
};

export const AudienceRequiredEmptyState: FC<AudienceRequiredEmptyStateProps> = ({ className }) => {
  const { t } = useTranslation('campaign');
  const history = useHistory();

  return (
    <section
      className={`bg-surface flex flex-col items-center rounded-3xl border border-secondary-border px-6 py-16 text-center shadow-sm md:px-10 md:py-20 ${className ?? ''}`}
    >
      <h2 className='text-2xl font-bold text-slate-900 md:text-[23px]'>{t('missingAudience.title')}</h2>
      <p className='text-secondary-600 mt-2 max-w-xl text-[15px] leading-relaxed'>{t('missingAudience.description')}</p>
      <Button
        intent='primary'
        size='md'
        className='mt-6 inline-flex items-center gap-2 px-5 py-3'
        onClick={() => history.push(RouteConstants.audiencesCreate)}
      >
        <HiPlus className='size-4' />
        {t('missingAudience.action')}
      </Button>
    </section>
  );
};
